import React from 'react';

function Howitwork() {
    return (
        <div className='how-it-works'>
            <div className='container'>
                <h2>How it works &#127891;</h2>
            <div className='flex'>
                    <div>
                        <span className='fas fa-home'></span>
                        <h4>Find a property</h4>
                        <p>to search and find the absolute desired property</p>
                    </div>
                    <div>
                        <span className='fas fa-dollar-sign'></span>
                        <h4>Buy the property</h4>
                        <p>to buy the assets according to market value</p>
                    </div>
                        <div>
                        <span className='fas fa-chart-line'></span>
                        <h4>Investing</h4>
                        <p>to take appropriate measures for securing capital</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Howitwork;
